module.exports = __webpack_public_path__ + "160x130_logo.png?324171bf698ba3b25a14dc035267ccfe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/160x130_logo.png
// module id = 1049
// module chunks = 0